/* JS commun du theme, repris tel quel des maquettes validees. */

/* ---------- Toast ---------- */
let toastTimer;
function toast(msg){
  const t = document.getElementById("toast");
  document.getElementById("toastMsg").textContent = msg;
  t.classList.add("show");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(()=>t.classList.remove("show"),2600);
}

/* ---------- Fleches carrousels ---------- */
/* Les carrousels s'enregistrent dans window.RAIL_SPLIDES quand ils sont montes
   (voir snippets/splide-loader.liquid + le JS de chaque section a carrousel).
   La lecture se fait au clic : le montage peut donc arriver apres ce binding. */
window.RAIL_SPLIDES = window.RAIL_SPLIDES || {};
window.FF_SPLIDES   = window.FF_SPLIDES || {};
document.querySelectorAll(".c-arrow[data-rail]").forEach(btn=>{
  btn.addEventListener("click",()=>{
    const splide = window.RAIL_SPLIDES[btn.dataset.rail];
    if(splide) splide.go(btn.dataset.dir === "1" ? ">" : "<");
  });
});

/* ---------- Reveal au scroll ---------- */
const io = new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});
},{threshold:.08});
document.querySelectorAll(".reveal").forEach(el=>io.observe(el));


/* ---------- Panier : compteur + total du header ---------- */
window.FF = window.FF || {};

/* Nombre d'ARTICLES, au sens du client : les unites de flocage n'en sont pas.
   cart.item_count les compte, lui — un maillot floque sur deux champs donnait
   « 3 » dans la pastille de l'en-tete alors que le tiroir affichait « Panier(1) ».
   Le tiroir a raison : on a commande un maillot. Le handle du produit Flocage
   vient du reglage du theme, porte par le panneau. */
window.FF.articleCount = function(cart){
  var panel = document.querySelector('[data-cart-panel]');
  var handle = (panel && panel.getAttribute('data-flocage-handle')) || 'flocage';
  var items = (cart && cart.items) || [];
  var n = 0;
  for (var i = 0; i < items.length; i++) {
    if (items[i].handle !== handle) n += items[i].quantity;
  }
  return n;
};

function refreshCartUI(cart){
  var n = window.FF.articleCount(cart);
  document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = n; });
  document.querySelectorAll('[data-cart-total]').forEach(function(el){ el.textContent = window.FF.money(cart.total_price); });
}
window.FF.money = function(cents){
  return (cents/100).toFixed(2).replace('.', ',') + ' €';
};
/* Ajoute PLUSIEURS lignes en une seule requete.
   C'est le point d'entree reel ; addToCart n'en est qu'un raccourci a une ligne.

   Pourquoi une seule requete : la fiche produit ajoute le maillot puis sa ligne
   « Flocage ». En deux appels, chacun emettait `ff:cart:updated` et lancait son
   propre rafraichissement du tiroir. Le premier partait avant que le flocage
   soit au panier — le serveur lui rendait donc un panier sans flocage — et
   quand sa reponse arrivait en dernier, elle ecrasait la bonne. Le tiroir
   affichait le maillot seul, au prix d'avant. Un seul appel, un seul
   evenement, plus de course. Et l'ajout devient tout ou rien : plus de panier
   a moitie rempli si la seconde requete echoue. */
window.FF.addLines = function(items){
  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json', 'Accept':'application/json'},
    body: JSON.stringify({ items: items })
  }).then(function(r){ return r.json(); })
    .then(function(){ return fetch(window.Shopify.routes.root + 'cart.js').then(function(r){ return r.json(); }); })
    .then(function(cart){ refreshCartUI(cart); window.FF.emitCartUpdated(cart); return cart; });
};
window.FF.addToCart = function(variantId, quantity, properties){
  return window.FF.addLines([{ id: variantId, quantity: quantity || 1, properties: properties || {} }]);
};
/* Evenements panier.
   `ff:cart:updated` est l'evenement historique du theme : le tiroir panier et le compteur de l'en-tete
   s'y accrochent, il est emis en premier et n'est jamais retire.
   `cart:updated` et `cart:refresh` sont les noms que la plupart des applications tierces ecoutent
   (upsell, lots, points de fidelite, paiement fractionne). Memes donnees, meme instant. */
window.FF.emitCartUpdated = function(cart){
  document.dispatchEvent(new CustomEvent('ff:cart:updated', {detail: cart}));
};
/* Relais : toute emission de `ff:cart:updated`, d'ou qu'elle vienne (fiche produit, carte produit,
   tiroir panier via assets/cart.js), est rediffusee sous les noms standards. Aucun evenement
   existant n'est retire ni renomme. */
document.addEventListener('ff:cart:updated', function(e){
  document.dispatchEvent(new CustomEvent('cart:updated', {detail: e.detail, bubbles: true}));
  document.dispatchEvent(new CustomEvent('cart:refresh', {detail: e.detail, bubbles: true}));
});

/* ---------- Ajout rapide depuis les cartes produit ---------- */
document.addEventListener('click', function(e){
  var btn = e.target.closest('[data-quick-add]');
  if(!btn) return;
  e.preventDefault();
  var id = btn.getAttribute('data-quick-add');
  if(!id) return;
  btn.disabled = true;
  window.FF.addToCart(id, 1).then(function(){
    toast(btn.title || 'Ajouté au panier');
    btn.disabled = false;
  }).catch(function(){ btn.disabled = false; });
});

/* ---------- BLOCAGE DU ZOOM SUR MOBILE ----------
   La balise viewport (maximum-scale, user-scalable) suffit sur Android, mais Safari iOS
   l'ignore volontairement depuis iOS 10. Les trois gestes de zoom sont donc neutralises un
   par un : le pincement Safari (evenements gesture*), le pincement multi-doigts generique,
   et le double tap.

   Deux precautions :
   - on ne bloque que les appareils a pointeur grossier, pour laisser le zoom navigateur
     intact sur ordinateur ;
   - touchmove n'est bloque QUE s'il y a plusieurs doigts a l'ecran, sinon on empecherait
     aussi le defilement de la page. */
(function(){
  if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) return;

  ['gesturestart','gesturechange','gestureend'].forEach(function(type){
    document.addEventListener(type, function(e){ e.preventDefault(); }, { passive: false });
  });

  document.addEventListener('touchmove', function(e){
    if (e.touches.length > 1) e.preventDefault();
  }, { passive: false });

  var dernierTap = 0;
  document.addEventListener('touchend', function(e){
    var maintenant = Date.now();
    if (maintenant - dernierTap <= 300) e.preventDefault();
    dernierTap = maintenant;
  }, { passive: false });
})();
